<template>
  <el-dialog
      :title="list.productName"
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">
    <el-descriptions title="商品信息" :class="'timeStamp'"
                     v-loading="loading"
                     :column="1">
      <el-descriptions-item label="商品名">{{
          list.productName
        }}
      </el-descriptions-item>
      <el-descriptions-item label="价格">{{ list.productPrice }} 元/次
      </el-descriptions-item>
      <el-descriptions-item label="使用次数">
        <el-input-number v-model="payList.buyCount" :step="1" step-strictly :min="1" size="mini"></el-input-number>
        次
      </el-descriptions-item>
      <el-descriptions-item label="说明" class="remark">{{ list.remark }}
      </el-descriptions-item>
    </el-descriptions>

    <span slot="footer" class="dialog-footer">
      <el-button @click="updateDialog(false)">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('wxpay')">微信支付</el-button>
      <el-button type="primary" @click="handleSubmit('alipay')">支付宝支付</el-button>
    </span>

    <pay-dialog
        v-if="payVisible"
        :visible.sync="payVisible"
        :payList="payList"
        :type="payList.payType"
        @closeAll="closeAll"/>
  </el-dialog>
</template>

<script>
import {defineComponent} from 'vue'
import PayDialog from "@/pages/customerEnterprise/productCenter/components/payDialog.vue";

export default defineComponent({
  name: "detail",
  components: {PayDialog},
  data() {
    return {
      list: {},
      visible: false,
      payVisible: false,
      loading: false,
      payList: {}
    }
  },
  methods: {
    handleSubmit(type) {
      this.payList.payType = type
      this.payList.productId = this.list.productId
      this.payVisible = true
    },
    open(item, payList) {
      this.visible = true
      this.list = item
      this.payList = payList
    },
    closeAll() {
      this.visible = false
      this.payVisible = false
    },
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.visible = value
      // this.$emit('update:visible', value);
    }
  }
})
</script>

<style scoped lang="less">

</style>
